module.exports = __webpack_public_path__ + "static/img/hero.f86e3e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero.png
// module id = mXZL
// module chunks = 1